import { render } from "./BoardSalesStatistics.vue?vue&type=template&id=14681fae"
import script from "./BoardSalesStatistics.vue?vue&type=script&lang=js"
export * from "./BoardSalesStatistics.vue?vue&type=script&lang=js"

import exportComponent from "/home/digital_profile_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__